'use client';

import Image from 'next/image';
import styled from 'styled-components';

import { SlideUp, SlideUpReverse } from '@/styles/animation';

const Container = styled.section`
  width: 100%;
  padding: 30px 20px var(--spacing-page-bottom);

  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.rootColor.black12};
  font-size: 24px;
  font-weight: 800;
  line-height: normal;
`;

const GuideContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 100%;
  gap: 20px;
`;

const GuideLinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 360px;
  width: 100%;
  height: 100%;
`;

const IconLink = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 66px;
  gap: 8px;

  animation: ${SlideUpReverse} 0.5s ease-in-out forwards;

  /* mouse In */
  &:hover {
    /* slide up */
    animation: ${SlideUp} 0.5s ease-in-out forwards;
  }

  /* mouse Out */
  &:not(:hover) {
  }
`;

const SVGImage = styled(Image)`
  width: 40px;
  height: 40px;
`;

const GuideTitle = styled.span`
  text-align: center;
  font-size: 12px;
  line-height: 120%;
  font-weight: 600;
`;

const GuidesSectionStyled = {
  Container,
  Title,
  GuideContainer,
  GuideLinkContainer,
  SVGImage,
  GuideTitle,
  IconLink,
};

export default GuidesSectionStyled;
